var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadIconBase = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9771 0C15.7189 0.470706 19.4982 4.22634 19.9493 8.98348C20.5007 14.4917 16.4908 19.3791 10.9771 19.9299V17.9269C14.6262 17.4962 17.4932 14.6019 17.9544 10.9564C18.4957 6.55984 15.378 2.56385 10.9771 2.02303V0.02003V0ZM8.97218 0.030045V2.03305C7.53864 2.23335 6.18529 2.81422 5.06252 3.71557L3.62897 2.23335C5.15274 0.971457 7.01735 0.22033 8.97218 0.030045ZM2.21548 3.64547L3.64902 5.07762C2.75682 6.20931 2.19543 7.56134 2.00496 8.98348H0C0.200496 7.02053 0.952355 5.16775 2.21548 3.64547ZM0.0100248 10.9865H2.01498C2.19543 12.4086 2.76684 13.7606 3.64902 14.8923L2.2255 16.3245C0.982429 14.8022 0.21052 12.9494 0.0100248 10.9865ZM5.06252 16.3645C6.19532 17.2459 7.54866 17.8167 8.97218 17.997V20C7.00732 19.7897 5.14271 18.9985 3.62897 17.7366L5.06252 16.3645ZM9.97466 5.47822L5.46351 9.98498H8.97218V13.991H10.9771V9.98498H14.4858L9.97466 5.47822Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadIconBase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload-icon-base.12785a99bf6eea2bd868c73383dfb12c.svg";